import axios from "axios";

import { authHeader } from "auth/authHeader";

const getBackendBaseUrl = () => {
  const backendUrl =
    process.env.REACT_APP_BACKEND_URL;

  if (!backendUrl) {
    throw new Error(
      "REACT_APP_BACKEND_URL is not configured.",
    );
  }

  return backendUrl.endsWith("/")
    ? backendUrl
    : `${backendUrl}/`;
};

const normalizeAppointmentId = (appointmentId) => {
  if (typeof appointmentId !== "string") {
    throw new TypeError(
      "A valid appointment ID is required.",
    );
  }

  const normalizedAppointmentId =
    appointmentId.trim();

  if (!normalizedAppointmentId) {
    throw new TypeError(
      "A valid appointment ID is required.",
    );
  }

  return normalizedAppointmentId;
};

export const getPatientConsultationContext =
  async (appointmentId) => {
    const normalizedAppointmentId =
      normalizeAppointmentId(appointmentId);

    const response = await axios.get(
      `${getBackendBaseUrl()}` +
        `consultation/patient/appointments/` +
        `${encodeURIComponent(normalizedAppointmentId)}`,
      {
        headers: authHeader(),
      },
    );

    const consultationContext =
      response?.data?.data;

    if (
      !consultationContext ||
      typeof consultationContext !== "object" ||
      Array.isArray(consultationContext)
    ) {
      throw new Error(
        "The consultation context response is invalid.",
      );
    }

    return consultationContext;
  };

const ConsultationService = {
  getPatientConsultationContext,
};

export default ConsultationService;